import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TableOutlinedSvg from "@ant-design/icons-svg/es/asn/TableOutlined";
import AntdIcon from "../components/AntdIcon";
var TableOutlined = function TableOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TableOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TableOutlined.displayName = 'TableOutlined';
}
export default /*#__PURE__*/React.forwardRef(TableOutlined);